import { createStore, createEffect, createEvent, combine } from 'effector';
import { $notificationStore } from '../notificationStore';
import { ApiUtils } from '@shared/utils';
import { TransferRequestsApi, type TransferRequestDeleteDocumentRequest } from '@shared/api';

const deleteDocumentEffect = createEffect((request: TransferRequestDeleteDocumentRequest) => TransferRequestsApi.deleteDocument(request));
const clearEvent = createEvent();

const $dataStore = createStore<string>('')
  .on(deleteDocumentEffect.done, (_, values) => values.result.data)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(deleteDocumentEffect.pending, (_, data) => data)
  .on(deleteDocumentEffect.fail, () => false)
  .on(deleteDocumentEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(deleteDocumentEffect, () => null)
  .on(
    deleteDocumentEffect.fail,
    (_, data) => ApiUtils.getApiErrorData(data.error, 'Something went wrong while deleting Document. Please try again.').message,
  )
  .on(deleteDocumentEffect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((error) => $notificationStore.events.setError(error));

export const $transferRequestsDeleteFileStore = {
  events: {
    update: deleteDocumentEffect,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
